// extracted by mini-css-extract-plugin
module.exports = {"itemStyle":"_3SQVBuWN"};